module.exports = __webpack_public_path__ + "img/11.9bf2ef61.png";